import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SettingsCard from "./SettingsCard";
import {
  FONT_OPTIONS,
  FONT_SIZE_OPTIONS,
  FONT_DROPDOWN_STYLE,
  FONT_SIZE_DROPDOWN_STYLE,
} from "./constants/fontConstants";

const HomePageHeadingsStylingSection = ({ inputData }) => {
  return (
    <SettingsCard
      title="Home Page - Main Content Styling"
      subtitle="Customize colors, fonts, and font sizes for main content"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        {/* Color Pickers - All in one row */}
        <Grid item xs={12}>
          <SoftBox display="flex" gap={2}>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <FormField
                defaultValue={inputData?.heading_1_color || "#000000"}
                className="color-input"
                label="Heading Color"
                name="heading_1_color"
                inputProps={{ type: "color" }}
              />
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <FormField
                defaultValue={inputData?.text_1_color || "#000000"}
                className="color-input"
                label="Text 1 Color"
                name="text_1_color"
                inputProps={{ type: "color" }}
              />
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <FormField
                defaultValue={inputData?.text_2_color || "#000000"}
                className="color-input"
                label="Text 2 Color"
                name="text_2_color"
                inputProps={{ type: "color" }}
              />
            </SoftBox>
          </SoftBox>
        </Grid>

        {/* Font Pickers - All in one row */}
        <Grid item xs={12}>
          <SoftBox display="flex" gap={2}>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Heading Font
                </SoftTypography>
              </SoftBox>
              <select
                name="heading_1_font"
                defaultValue={inputData?.heading_1_font || "Poppins"}
                style={FONT_DROPDOWN_STYLE}
              >
                {FONT_OPTIONS.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Text 1 Font
                </SoftTypography>
              </SoftBox>
              <select
                name="text_1_font"
                defaultValue={inputData?.text_1_font || "Poppins"}
                style={FONT_DROPDOWN_STYLE}
              >
                {FONT_OPTIONS.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Text 2 Font
                </SoftTypography>
              </SoftBox>
              <select
                name="text_2_font"
                defaultValue={inputData?.text_2_font || "Poppins"}
                style={FONT_DROPDOWN_STYLE}
              >
                {FONT_OPTIONS.map((font) => (
                  <option key={font} value={font}>
                    {font}
                  </option>
                ))}
              </select>
            </SoftBox>
          </SoftBox>
        </Grid>

        {/* Font Size Pickers - All in one row */}
        <Grid item xs={12}>
          <SoftBox display="flex" gap={2}>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Heading Font Size
                </SoftTypography>
              </SoftBox>
              <select
                name="heading_1_font_size"
                defaultValue={inputData?.heading_1_font_size || "24px"}
                style={FONT_SIZE_DROPDOWN_STYLE}
              >
                {FONT_SIZE_OPTIONS.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Text 1 Font Size
                </SoftTypography>
              </SoftBox>
              <select
                name="text_1_font_size"
                defaultValue={inputData?.text_1_font_size || "16px"}
                style={FONT_SIZE_DROPDOWN_STYLE}
              >
                {FONT_SIZE_OPTIONS.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </SoftBox>
            <SoftBox display="flex" flexDirection="column" flex={1}>
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  Text 2 Font Size
                </SoftTypography>
              </SoftBox>
              <select
                name="text_2_font_size"
                defaultValue={inputData?.text_2_font_size || "16px"}
                style={FONT_SIZE_DROPDOWN_STYLE}
              >
                {FONT_SIZE_OPTIONS.map((size) => (
                  <option key={size} value={size}>
                    {size}
                  </option>
                ))}
              </select>
            </SoftBox>
          </SoftBox>
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default HomePageHeadingsStylingSection;
